import React from 'react';
import styled from 'styled-components';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
function createData(name, cnpj = '', banco = '', banco1 = '', banco2 = '', agencia = '', conta = '') {
  return { name, cnpj, banco, banco1, banco2, agencia, conta };
}

const rows = [
  createData('Nome da empresa', 'Ouro Minas LTDA'),
  createData('CNPJ', '12.152.669/0001-88'),
  createData('Banco', 'Banco 01', 'Banco 02'),
  createData('Agência','6667-X'),
  createData('Conta Corrente', '000100-0'),
];

export default function PagamentoTed() {
  return (
    <div className="my-4">
      <TituloPagamento>Dados para pagamento via TED</TituloPagamento>

      <PagamentoTransferencia>
        <TableContainer component={Paper} style={{ marginTop: '15px' }}>
          <Table>
            <TableBody>
              {rows.map((row) => (
                <TableRow
                  key={row.name}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {row.name}
                  </TableCell>
                  <TableCell align="right" sx={{ padding: '3px' }}>
                    {row.cnpj}
                  </TableCell>
                  <TableCell align="right" sx={{ padding: '3px' }}>
                    {row.banco1}
                  </TableCell>
                  <TableCell align="right" sx={{ padding: '3px' }}>
                    {row.agencia}
                  </TableCell>
                  <TableCell align="right" sx={{ padding: '3px' }}>
                    {row.conta}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TableContainer component={Paper} style={{ marginTop: '15px' }}>
          <Table>
            <TableBody>
              {rows.map((row) => (
                <TableRow
                  key={row.name}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {row.name}
                  </TableCell>
                  <TableCell align="right" sx={{ padding: '3px' }}>
                    {row.cnpj}
                  </TableCell>
                  <TableCell align="right" sx={{ padding: '3px' }}>
                    {row.banco2}
                  </TableCell>
                  <TableCell align="right" sx={{ padding: '3px' }}>
                    {row.agencia}
                  </TableCell>
                  <TableCell align="right" sx={{ padding: '3px' }}>
                    {row.conta}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </PagamentoTransferencia>
      <ContainerButtons>
        <div>
                <p>
                  Pague e será creditado em instantes.
                </p>
              </div>
              </ContainerButtons>
    </div>
  );

}

const TituloPagamento = styled.h4`
  margin: 0 0 30px;
  color: var(--light);
  font-weight: 700;
  font-size: 20px;
  text-align: center;
`;

const PagamentoTransferencia = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 830px) {
    flex-direction: row;

    div {
      margin: 0 15px 0 15px;
    }
  }
`;

const ContainerButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  div:nth-child(n) {
    padding: 5px 0;
    border-top: 1px solid black;
        align-self: center;

    text-align: -webkit-center;

  }
`;